<template>
  <div class="head-info">
    <div class="infoList" v-for="(item, i) in infoList.filedVoList" :key="i">
      <div class="infoName">{{ item.filedName }}</div>
      <div class="info">
        <div class="infoData">{{ item.value }}</div>
        <div class="infoUnit">{{ item.filedUnit }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["infoData"],
  data() {
    return { 
      infoList:{
        name:'',
        list:[],
        getDataInterval: null,
      },
    };
  },
  mounted() {
     this.getDataInterval = setInterval(() => {
        this.infoList = this.infoData; 
    },2000)
  },
  methods: {

  },
  destroyed(){
    //清除定时器
    if (this.getDataInterval)  clearInterval(this.getDataInterval);
  }
};
</script>
<style lang="less" scoped>
.head-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .infoList {
    width: 153.6px;
    height: 56px;
    background: url("./images/info-border.png") no-repeat 0 0;
    background-size: 100% 100%;
    margin-bottom: 9.6px;

    .infoName {
      width: 100%;
      height: 24px;
      background: rgba(0, 0, 0, 0.1)
        linear-gradient(
          90deg,
          rgba(0, 145, 255, 0.1) 0%,
          rgba(0, 145, 255, 0.6) 48%,
          rgba(0, 145, 255, 0.1) 100%
        );
      text-align: center;
      line-height: 24px;
      font-size: 14.4px;
      font-weight: 400;
      color: #ffffff;
    }

    .info {
      width: 100%;
      height: 32px;
      display: flex;
      justify-content: center;

      .infoData {
        font-size: 19.2px;
        font-weight: 600;
        text-align: center;
        line-height: 32px;
        color: #ff7700;
        background: linear-gradient(180deg, #ffffff 0%, #00dbff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-right: 4px;
      }

      .infoUnit {
        font-size: 14.4px;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
      }
    }
  }
}
</style>